import { useEffect, useState } from 'react';

// ------------------------------------------------------------
// Hook: load an image URL for Konva rendering.
// ------------------------------------------------------------

export function useLayoutImage(url: string | null | undefined) {
  const [image, setImage] = useState<HTMLImageElement | null>(null);
  const [status, setStatus] = useState<'idle' | 'loading' | 'loaded' | 'error'>(
    'idle',
  );

  useEffect(() => {
    if (!url) {
      setImage(null);
      setStatus('idle');
      return;
    }

    let cancelled = false;
    const img = new window.Image();
    img.crossOrigin = 'anonymous';
    setStatus('loading');

    img.onload = () => {
      if (!cancelled) {
        setImage(img);
        setStatus('loaded');
      }
    };
    img.onerror = () => {
      if (!cancelled) {
        setImage(null);
        setStatus('error');
      }
    };
    img.src = url;

    return () => {
      cancelled = true;
    };
  }, [url]);

  return { image, status };
}

export function loadImageDimensions(
  file: File,
): Promise<{ width: number; height: number }> {
  return new Promise((resolve, reject) => {
    const url = URL.createObjectURL(file);
    const img = new window.Image();
    img.onload = () => {
      resolve({ width: img.naturalWidth, height: img.naturalHeight });
      URL.revokeObjectURL(url);
    };
    img.onerror = () => {
      URL.revokeObjectURL(url);
      reject(new Error('Failed to read image dimensions'));
    };
    img.src = url;
  });
}
